<template>
  <v-btn
    :to="{
      name: 'BatchDetailView',
      params: { batchid: instance.id, id: instance.project }
    }"
    color="primary"
    rounded
    outlined
    small
  >
    <v-icon left small>{{ instance.icon }}</v-icon>
    {{ instance.forgeID }}
  </v-btn>
</template>

<script>
export default {
  name: "BatchNavigation",
  props: {
    instance: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
};
</script>
